import React from 'react';
import { Title } from '@nimbus-ds/components';

function MoneySkeleton(): JSX.Element {
  return <Title.Skeleton as="h4" width="150px" />;
}

export default MoneySkeleton;
